var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"ly-tab-item",style:(_vm.$parent.value === _vm.id ? _vm.activeStyle : {}),on:{"click":_vm.onItemClicked}},[(_vm.$parent.fixBottom)?_c('div',{staticClass:"ly-tab-item-icon"},[_vm._t("icon")],2):_vm._e(),_c('div',{staticClass:"ly-tab-item-label"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }